import { useMemo } from "react";
import { TimeProps } from "@common/types";
import { useIsRtl } from "@app/hooks";

export function Time({
  date,
  option,
  ...rest
}: TimeProps & React.TimeHTMLAttributes<HTMLElement>) {
  const isRtl = useIsRtl();
  const memoDate = useMemo(
    () => (typeof date === "string" ? new Date(date) : date),
    [date],
  );

  return (
    <time dateTime={memoDate.toISOString()} {...rest}>
      {new Intl.DateTimeFormat(
        isRtl ? "fa-IR" : "en-us",
        option
          ? option
          : {
              dateStyle: "full",
              timeStyle: "long",
            },
      ).format(memoDate)}
    </time>
  );
}
